import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators ,FormsModule,NgForm, FormControl, FormGroupDirective } from '@angular/forms';
import { AuthService } from '../_service/auth.service';
import { AlertifyService } from '../_service/alertify.service';
import { SendMailService } from '../_service/send-mail.service';
import { Router } from '@angular/router';
import { ContactUsService } from '../_service/contactUs.service';
import { ErrorStateMatcher } from '@angular/material';

@Component({
  selector: 'help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.css']
})
export class HelpComponent implements OnInit {

  contactUs: ContactUsInterface = {
    fullName: '',
    emailAddress: '',
    healthAuthority: '',
    facility: '',
    phoneNumber: '',
    subject: '',
    message: ''
  };

  model: any = {};
  selectedSearchParameter = 'General Question';
  contactUsForm: FormGroup;
  name: string = '';
  emailAddress: string = '';
  healthAuthority: string = '';
  facility: string = '';
  phoneNumber: string = '';
  subject: string = '';
  message: string = '';
  loading = false;
  
  constructor(
    public fb: FormBuilder,
    public authService: AuthService,
    private router: Router,
    private alertify: AlertifyService,
    private contactUsService: ContactUsService
  ) 
  { 
    this.contactUsForm = fb.group({
      fullNameFormControl : new FormControl('', [
        Validators.required,
        Validators.maxLength(125),
        this.WhitespaceValidator
      ]),
    //   healthAuthorityFormControl : new FormControl('', [
    //     Validators.required,
    //     this.WhitespaceValidator
    //   ]),
    //  facilityFormControl : new FormControl('', [
    //     Validators.required,
    //     this.WhitespaceValidator
    //   ]),
      phoneNumberFormControl : new FormControl('', [
        Validators.required,
        Validators.maxLength(20),
        this.WhitespaceValidator,
      ]),
      messageFormControl : new FormControl('', [
        Validators.required,
        this.WhitespaceValidator
      ]),
      emailFormControl : new FormControl('', [
        Validators.required,
        Validators.email,
        this.WhitespaceValidator,
        Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+[.]{1}[a-zA-Z]{2,}$'),
      ])
    });
  }

  subjectFormControl = new FormControl('', [
    Validators.required,
  ]);

  public WhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
}

  onSelectSubject(event) {

    if (event.value === 'General Question') {
      this.selectedSearchParameter = event.value;
    }
    if (event.value === 'Product Information') {
      this.selectedSearchParameter = event.value;
    }
    if (event.value === 'Account Information') {
      this.selectedSearchParameter = event.value;
    }
    if (event.value === 'Other') {
      this.selectedSearchParameter = event.value;
    }
    // console.log(this.selectedSearchParameter);
  }

  resetForm() {
    this.selectedSearchParameter = 'General Question';
    this.contactUsForm.reset();
    this.subjectFormControl.reset(this.selectedSearchParameter);
  }

  ngOnInit() {
  }

  contactUsFunction() {
    this.loading = true;
    this.contactUs.fullName = this.contactUsForm.get('fullNameFormControl').value.trim();
    this.contactUs.emailAddress = this.contactUsForm.get('emailFormControl').value.trim();
    // this.contactUs.healthAuthority = this.contactUsForm.get('healthAuthorityFormControl').value;
    // this.contactUs.facility = this.contactUsForm.get('facilityFormControl').value;
    this.contactUs.phoneNumber = this.contactUsForm.get('phoneNumberFormControl').value.trim();
    this.contactUs.subject = this.selectedSearchParameter.trim();
    // this.contactUs.message = this.contactUsForm.get('messageFormControl').value.trim();

    if (this.contactUsForm.controls.messageFormControl.value === null) {
      this.contactUs.message = 'N/A';
    } else {
      this.contactUs.message = this.contactUsForm.get('messageFormControl').value;
    }

    return this.contactUsService.contactUsForm(this.contactUs).subscribe(res => {
      // console.log(this.contactUs);
      this.loading = false;
      this.alertify.success('Thank you for contacting us! Your email was successfully sent.');
      this.resetForm();
    },
    error => {
      this.loading = false;
      this.alertify.error('Something went wrong. Please try again!');
    });
  }
}

export class ContactUsInterface {
  fullName: string;
  emailAddress: string;
  healthAuthority: string;
  facility: string;
  phoneNumber: string;
  subject: string;
  message: string;
}